




































import { defineComponent } from '@vue/composition-api';
import { PRODUCTS_MAX_NUM } from '@tt4b/ttam-enums';
import { MessageBox } from 'byted-vui';
import { i18n } from './../../../../i18n';

const name = 'ttam-products-list-actions';

export default defineComponent({
  name,
  props: {
    clearable: {
      type: Boolean,
      default: true,
    },
    currentNum: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: PRODUCTS_MAX_NUM,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    addShowKey: {
      type: String,
      default: '',
    },
    addClickKey: {
      type: String,
      default: '',
    },
    clearShowKey: {
      type: String,
      default: '',
    },
    clearClickKey: {
      type: String,
      default: '',
    },
  },
  setup(props, { emit }) {
    const onClear = () => {
      MessageBox.confirm(
        i18n.t('clear_product_confirm_modal_content') as string,
        i18n.t('clear_product_confirm_modal_title') as string,
        {
          showClose: false,
          confirmButtonText: i18n.t('module_common_clear') as string,
        },
      ).then(() => {
        emit('clear');
      });
    };
    const onAdd = () => {
      emit('add');
    };
    return {
      name,
      onAdd,
      onClear,
    };
  },
});
